import type { InputBaseComponentProps } from '@mui/material'

/** Disable Lastpass and Dashlane and other autocompletes */
export const disableAutocomplete: InputBaseComponentProps = {
  autoComplete: 'off',
  /** @see https://dashlane.github.io/SAWF/#mozTocId902224 */
  // dataFormType: 'other',
  // dataLpignore: true,
}
